/**
 * Cookie-consent helpers — GDPR-compliant 3-button banner with category
 * toggles. Persisted in localStorage under `tnm_cookie_consent_v1`.
 *
 * Shape:
 *   {
 *     necessary: true,   // always true
 *     analytics: bool,
 *     marketing: bool,
 *     timestamp: ISO string
 *   }
 */
const STORAGE_KEY = "tnm_cookie_consent_v1";

export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_e) {
    return null;
  }
}

export function setCookieConsent(prefs) {
  const payload = {
    necessary: true,
    analytics: !!prefs?.analytics,
    marketing: !!prefs?.marketing,
    timestamp: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    console.warn("Cookie consent save failed (localStorage disabled?)", e);
  }
  // Notify the rest of the app (e.g. AnalyticsInstaller) so it can react.
  window.dispatchEvent(new CustomEvent("tnm-cookie-consent-change", { detail: payload }));
  return payload;
}

export function clearCookieConsent() {
  try { localStorage.removeItem(STORAGE_KEY); }
  catch (e) { console.warn("Cookie consent clear failed", e); }
  window.dispatchEvent(new CustomEvent("tnm-cookie-consent-change", { detail: null }));
}

/** Check whether a category is allowed (false when no choice made yet). */
export function isCategoryAllowed(category) {
  const c = getCookieConsent();
  if (!c) return false;
  if (category === "necessary") return true;
  return !!c[category];
}

/** Open the preferences modal from anywhere via the global event. */
export function openCookiePreferences() {
  window.dispatchEvent(new Event("tnm-open-cookie-preferences"));
}
